import React from 'react';

function Documents() {
    const documentTypes = [
        'Maklervertrag',
        'Vertrag Wertermittlung',
        'DSGVO-Erklärung',
        'Widerspruchsfrist-Verzicht'
    ];

    return (
        <div>
            <h1>Dokumente</h1>
            <ul>
                {documentTypes.map((type, index) => (
                    <li key={index}>{type}</li>
                ))}
            </ul>
        </div>
    );
}

export default Documents;
